var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.893,
    height: 21.411,
    viewBox: "0 0 17.893 21.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(-1.85 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38568",
    "data-name": "Path 38568",
    d: "M16.954,7.41V6.157a6.157,6.157,0,1,0-12.315,0V7.41A4.4,4.4,0,0,0,2,11.435v5.278a4.4,4.4,0,0,0,4.4,4.4h8.8a4.4,4.4,0,0,0,4.4-4.4V11.435A4.4,4.4,0,0,0,16.954,7.41ZM6.4,6.157a4.4,4.4,0,1,1,8.8,0v.88H6.4ZM17.833,16.713a2.639,2.639,0,0,1-2.639,2.639H6.4a2.639,2.639,0,0,1-2.639-2.639V11.435A2.639,2.639,0,0,1,6.4,8.8h8.8a2.639,2.639,0,0,1,2.639,2.639Z",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38569",
    "data-name": "Path 38569",
    d: "M12,14a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V15A1,1,0,0,0,12,14Z",
    transform: "translate(-1.204 -2.022)",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change_password.864c43cb81b5ce9c8f062a9497651610.svg";
export { ForwardRef as ReactComponent };